module.exports = __webpack_public_path__ + "static/media/thick.c60ee8f7.svg";